import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import store from './redux/store/store';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';

console.log("%c 2.2 %cUTP-POSTGRADO","padding: 5px; border-radius: 4px 0 0 4px; background: linear-gradient(#a2c70d, #3F9E85 ); color: #FFF; text-transform: uppercase; font-size: 10px;font-family: sans-serif;font-weight: bold;text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.3)","padding: 5px; border-radius: 0 4px 4px 0; background-color: #fe861e; color: #FFF; text-transform: uppercase; font-size: 10px;font-family: sans-serif");

ReactDOM.render(
  <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>, document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

// "numdoc" : "72005107",
// "emailPrincipal" : "frey.medinaa@gmail.com"

// "numdoc" : "47236953",
// "emailPrincipal" : "gilbertdominguez701@gmail.com"

// "numdoc" : "76699672",
// "emailPrincipal" : "robinzon037rbn@gmail.com"

// "numdoc" : "5780501",
// "emailPrincipal" : "jaburto@utp.edu.pe"

// jcorbacho06@gmail.com
// 43618992


reportWebVitals();
